/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React, { Component } from 'react';
// styles
import injectSheet from "react-jss";
import styles from 'material/imageupload/components/gif/gif_styles';



/* ========== ~~~~~~~~~~ IMAGE UPLOAD : GIF ~~~~~~~~~~ ========== */
class Gif extends Component{
    render(){
        return <div className={`gif ${this.props.classes.gif}`} >
            <p className={`cropperTitle`} >Upload Image</p>
            <img src={this.props.src} alt={''} />
        </div>
    }
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default injectSheet(styles)(Gif);
